export default [
    {
        step: 1,
        name: 'StafetDeltagSomFighterStepOne',
        completed: false,
        label: 'formStepLabel1',
        hidden: false
    },
    {
        step: 2,
        name: 'StafetDeltagSomFighterStepTwo',
        completed: false,
        label: 'formStepLabel2',
        hidden: false
    },
    {
        step: 3,
        name: 'StafetDeltagSomFighterStepThree',
        completed: false,
        label: 'formStepLabel3',
        hidden: false
    },
    {
        step: 4,
        name: 'FormStepSubmitting',
        completed: false,
        label: '',
        hidden: true
    }
]
